<div class="h-100 w-100 d-flex flex-column" [class.position-relative]="!help.absolute">
	<div class="flex-grow-1 d-flex justify-content-end">
		<a
			class="d-flex app-link-dark pe-2 pt-2 abs-pos"
			(click)="openHelp()"
			ngbTooltip="{{ 'administration-help.help' | translate }}"
			tooltipClass="ngbTooltipClass"
			container="body">
			<div>{{ help.text | translate }}</div>
			@if (help.icon) {
				<div class="bg-gray-600 grid-mask-img help-mask-img zindex-fixed size-1-5rem mask-settings"></div>
			}
		</a>
	</div>
	<div class="h-100 w-100 d-flex align-items-center justify-content-center">
		<!-- <div class="h-100 w-100" [class.pb-3]="!help.absolute" [class.mb-1]="!help.absolute"> -->
		<ng-content></ng-content>
		<!-- </div> -->
	</div>
</div>
